import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

export const PublicRoute = ({
  isAuthenticated,
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    component={(props) =>
      isAuthenticated ? (
        <Redirect to="/" />
      ) : (
        <div>
          <Component {...props} />
        </div>
      )
    }
  />
);

const mapStateToProps = (state) => ({
  //isAuthenticated: !!state.auth.uid,
  isAuthenticated: !!state.auth.uid && !!state.auth.emailVerified,
});

export default connect(mapStateToProps)(PublicRoute);
